import { send } from "../../send";

/**
 * send(1.method, 2.url, 3.data, 4.expend) 1.请求类型 2.请求地址 3.请求参数 4.拓展(如统一的uuid)
 * 系统模块
 */

export const System = {
    // user用户
    getUserList(parmas, expend) { // 查询用户
        return send("GET", "/api/company/user/find", parmas, expend);
    },
    postUserAdd(parmas, expend) { // 添加用户
        return send("POST", "/api/company/user/create", parmas, expend);
    },
    postUserEdit(parmas, expend) { // 编辑修改用户
        return send("POST", "/api/company/user/update", parmas, expend);
    },
    postUserDel(parmas, expend) { // 删除用户
        return send("POST", "/api/company/user/delete", parmas, expend);
    },
    // role角色
    getUserRoleEnum(parmas, expend) { // 获取用户角色列表
        return send("GET", "/api/company/user/role/find", parmas, expend);
    },
    postRoleAdd(parmas, expend) { // 添加角色
        return send("POST", "/api/company/user/role/create", parmas, expend);
    },
    postRoleEdit(parmas, expend) { // 更新角色
        return send("POST", "/api/company/user/role/update", parmas, expend);
    },
    postRoleIsSystem(parmas, expend) { // 更换角色启用状态
        return send("POST", "/api/company/user/enabled", parmas, expend);
    },
    postRoleDel(parmas, expend) { // 删除角色
        return send("POST", "/api/company/user/role/delete", parmas, expend);
    },
    getRoleDeils(parmas, expend) {
        return sned("GET", "/api/company/user/role/get/" + parmas.id, {}, expend);
    },
    // power权限
    getPowerList(parmas, expend) { // 获取权限列表
        return send("GET", "/api/company/user/role/permission/find", parmas, expend);
    },
    getRolePower(parmas, expend) { // 获取角色权限详情
        return send("GET", "/api/company/user/role/get/" + parmas.id, null, expend);
    },
}